import { makeServerRequest, makeServerPut} from './util';

const apiPrefix = "api/v1";

export function fetchOrganizationsSuccess(organizations) {
    return {
        type: "FETCH_ORGANIZATIONS_SUCCESS",
        payload: organizations
    };
}

export function fetchOrganizationsFailure(error) {
    return {
        type: "FETCH_ORGANIZATIONS_FAILURE",
        payload: error
    };
}

export const fetchOrganizations = () => {

    return (dispatch) => {
        dispatch({type: "FETCH_ORGANIZATIONS"});

        return makeServerRequest(apiPrefix + "/organizations").then(
            response => dispatch(fetchOrganizationsSuccess(response.data))
        ).catch(
            error => dispatch(fetchOrganizationsFailure(error))
        );
    };
};

export const linkOrganizationToCustomerSuccess = () => {
    return {
        type: "LINK_ORGANIZATION_TO_CUSTOMER_SUCCESS",
    };
};

export const linkOrganizationToCustomerFailure = (error) => {
    return {
        type: "LINK_ORGANIZATION_TO_CUSTOMER_FAILURE",
        payload: error
    };
};

export const linkOrganizationToCustomer = (organizationId, customerId) => {
    return (dispatch) => {
        dispatch({type: "LINK_ORGANIZATION_TO_CUSTOMER"});

        return makeServerPut(apiPrefix + "/organizations/" + organizationId + "/link/" + customerId).then(
            response => dispatch(linkOrganizationToCustomerSuccess())
        ).catch(
            error => dispatch(linkOrganizationToCustomerFailure(error))
        );
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/organizations.js